import { gql } from '@apollo/client'

export const GET_ALL_GROUPS = gql`
  query GetAllGroups {
    getAllGroups {
      id
      name
    }
  }
`

export const GET_DIRECTORY_GROUPS = gql`
query GetDirectoryGroups {
  getDirectoryGroups {
    icon
    description
    name
    id
    CategoriesOfGroup {
      id
      group_id
      name
      description
      icon
      GroupsCategoriesSubOfGroupsCategory {
        id
        group_category_id
        name
        description
        icon
        form_id
      }
    }
  }
}
`